<template>
  <!-- 成员 -->
  <div class="tab-pane">
    <p class="gov-p">
      <el-button type="primary" @click="dialogVisible = true">邀请成员</el-button>
    </p>
    <template>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="姓名" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账号" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.role==1">管理员</span>
            <span v-if="scope.row.role==2">普通用户</span>
          </template>
        </el-table-column>
        <el-table-column label="日期" width="250">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ formatTime(scope.row.createtime)  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="small" v-if='isShowBtb(scope.row)' type="danger" @click="handleDelete(scope.$index, scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-dialog title="邀请成员" :visible.sync="dialogVisible" size="tiny">
      <el-form ref="testform" :rules="rules" :model="formlist">
        <el-form-item prop="tel">
          <realSearch style="width:100%" @change="saveTel" placeholder="填写成员的手机号账号"></realSearch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addUser">确 定</el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
import company from '../../data/basic/plan/company.js'
import usermember from '../../data/basic/plan/usermember.js'
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
import realSearch from '../../components/unit/searchTel.vue'

export default {
  data() {
    return {
      dialogVisible: false,
      currRole: -1,
      selectlist: {
        listchild: '',
      },
      options: [],
      optionslist: [],
      // 显示权限
      popen: 1,
      status: 0,
      tableData: [],
      rules: {
        tel: [{
          required: true,
          message: '请输入被邀请人的手机号码',
          trigger: 'blur'
        }],
      },
      formlist: {
        tel: '',
      },
      // 权限控制
      roleman: '',
      // 移交手机号
      changephone: '',
      roleshow: true,
      showspan: false
    }
  },
  computed: {
    ...mapState({
      valbody(state) {
        return state.valbody
      }
    })
  },
  created() {
    this.getUser()
    this.status = sessionStorage.orgStatus
  },
  methods: {
    ...mapMutations(['dataGovForm']),
    // 模糊搜索
    saveTel(val) {
    this.formlist.tel = val
    },
    // 邀请成员
    addUser() {
      (async() => {
        let getState = await usermember.add_member({
          phone: this.formlist.tel,
          subjectId: sessionStorage.currenOrgId
        })
        if (getState.status) {
          this.$message.success('成员邀请成功')
          this.getUser()
          this.dialogVisible = false
        } else {
          this.$message.error(getState.msg)
        }
      })()
    },
    // 邀请方法
    onclickphone() {
      this.$refs['testform'].validate((valid) => {
        if (valid) {
          switch (JSON.parse(this.valbody.type)) {
            case 0:
              this.addUser()
              break;
            case 1:
              this.addUser()
              break;
            case 2:
              this.addUser()
              break;
            case 3:
              this.addUser()
              break;
            case 4:
              this.addUser()
              break;
          }
          this.dialogVisible = false
        } else {
          console.log('错误 submit!!');
          return false;
        }
      });
    },
    // 刷新列表
    refshCurrentList() {
      switch (this.valbody.regionType) {
        case 0:
          this.getUser({
            subjectIds: sessionStorage.currenOrgId,
          })
          break;
        case 1:
          this.getUser({
            subjectIds: sessionStorage.currenOrgId,
          })
          break;
        case 2:
          this.getUser({
            subjectIds: sessionStorage.currenOrgId,
          })
          break;
        case 3:
          this.getUser({
            subjectIds: sessionStorage.currenOrgId,
          })
          break;
        case 4:
          this.getUser({
            subjectIds: sessionStorage.currenOrgId,
          })
          break;
      }
    },
    // 处理管理员与普通用户的权限控制
    isShowBtb(row) {
      if (row.role === 2 && row.phone !== sessionStorage.currentLoginUser) {
        return true
      } else if (row.role === 2 && row.phone === sessionStorage.currentLoginUser) {
        return false
      } else {
        if (row.role == 1 && row.phone !== sessionStorage.currentLoginUser) {
          return false
        } else if (row.role == 1 && row.phone === sessionStorage.currentLoginUser) {
          return false
        } else {
          return true
        }
      }
    },
    // 获取政府用户列表
    getUser() {
      (async() => {
        let getState = await usermember.get_user({
          subjectIds: sessionStorage.currenOrgId,
        })
        if (getState.status) {
          this.tableData = getState.data.content
        } else {
          this.$message.error(getState.msg)
        }
      })()
    },
    // 移除成员
    removeUser(params) {
      (async() => {
        let getState = await usermember.remove_member(params)
        if (getState.status) {
          this.$message.success('成员移除成功')
          this.getUser()
        } else {
          this.$message.error(getState.msg)
        }
      })()
    },
    // 打开退出
    Signout() {
      this.dialogclose = true
    },
    // 退出
    close() {
      this.delectUser()
      this.dialogclose = false
    },
    //  设置移交申报单位
    clicktransfer() {
      this.dialogtransfer = true
    },
    // 格式化时间
    formatTime(time) {
      return moment(time).format('YYYY/MM/DD HH:mm:ss')
    },
    // 选中需要移交的手机号
    changeIphone(val) {
      this.changephone = val
    },
    // 移除成员
    handleDelete(index, row) {
      switch (JSON.parse(sessionStorage.orgStatus)) {
        case 0:
          this.removeUser({
            subjectId: row.subjectId,
            phone: row.phone
          })
          break;
        case 1:
          this.removeUser({
            subjectId: row.subjectId,
            phone: row.phone
          })
          break;
        case 2:
          this.removeUser({
            subjectId: row.subjectId,
            phone: row.phone
          })

          break;
        case 3:
          this.removeUser({
            subjectId: row.subjectId,
            phone: row.phone
          })
          break;
        case 4:
          this.removeUser({
            subjectId: row.subjectId,
            phone: row.phone
          })
          break;
      }
    },
    // 点击
    confirm() {
      this.$router.push('/editunit')
    },
  },
  components: {
    realSearch
  }
}

</script>
<style lang="stylus" scoped>
.org-control {
  margin-left: 60px
}

.gov-p {
  margin-bottom: 15px
}

.org-p1 {
  margin-left: 15px;
}

.el-select {
  width: 300px;
}

.p-color1 {
  color: #000;
  font-size: 16px;
}

.p-color2 {
  margin-top: 20px;
  color: #ccc;
  font-size: 12px;
}
.tab-pane{
  margin:0 15px;
}

</style>



// WEBPACK FOOTER //
// member.vue?5f32654a